import {emotionStyled, tokens} from '@packages/utilities/styled';

export const NumberInputPrefixView = emotionStyled('div')(
  {
    display: 'flex',
    alignItems: 'center',
    background: '$uiInputBackground',
    borderTop: '$border2',
    borderBottom: '$border2',
    borderLeft: '$border2',
    borderRadius: '$2 0 0 $2',
    fontSize: '$body',
    lineHeight: '$body',
    paddingLeft: tokens.ui.numberInput.input.withPrefixOrSuffix.paddingX,
  },
  {
    componentName: 'NumberInputPrefix',
  }
);
